import { useContext } from 'react';
import UserContext from '../context/UserContext';

const useAuth = () => {
  const { user } = useContext(UserContext);
  const isAdmin = user && user.email === "adamkfrancis1989@gmail.com";
  return { isAdmin };
};

export default useAuth;
